export default __webpack_public_path__ + "static/media/individualservo.83ad7b7f.svg";